export const EQUITY_COMPLETED_ORDER_STATUS = ['EXECUTED'];
export const EQUITY_CANCEL_ORDER_STATUS = ['CANCELLED', 'AMOWITHDRAWN'];
export const EQUITY_REJECTED_ORDER_STATUS = [
	'OMSREJECT',
	'ORDERERROR',
	'ADMINREJECT',
	'AMOCANCELLED',
	'GATEWAYREJECT',
];
export const EQUITY_OPEN_ORDER_STATUS = [
	'PENDING',
	'In process',
	'OMSXMITTED',
	'EXCHANGE_XMITTED',
	'amo_submitted',
];

export const OPEN_ORDER_MESSAGE = 'Order is waiting for execution';
export const COMPLETED_ORDER_MESSAGE = 'Order completed';
export const CANCELED_ORDER_MESSAGE = 'Order cancelled';
export const REJECTED_ORDER_MESSAGE = 'Order rejected';

export const VIEW_DETAILS_BT_TEXT = 'View details';
export const CHART_BT_TEXT = 'Chart';

export const TRADE_SIP_ORDER_STATUS = {
	ACTIVE: 'ACTIVE',
	PAUSED: 'PAUSED',
	CANCELLED: 'CANCELLED',
};

export const FRIENDLY_SIP_ORDER_STATUS = {
	ACTIVE: 'ACTIVE',
	IN_PROGRESS: 'INPROGRESS',
	PAUSED: 'PAUSED',
	CANCELLED: 'CANCELLED',
};

export const RESPONSE_SIP_ORDER_STATUS = {
	PENDING: 'PENDING',
	RUNNING: 'RUNNING',
	STOPPED: 'STOPPED',
	CANCELLED: 'CANCELLED',
};

export const SIP_ACTION_TEXT = {
	[RESPONSE_SIP_ORDER_STATUS.RUNNING]: 'Pause SIP',
	[RESPONSE_SIP_ORDER_STATUS.PENDING]: 'Cancel SIP',
	[RESPONSE_SIP_ORDER_STATUS.STOPPED]: 'Resume SIP',
};

export const DEFAULT_SIP_FILTER_METADATA = {
	friendly_status: [],
};

export const ORDER_BOOK_FOOTER_NAV_ACTIONS = {
	reorder: 'reorder',
	modify: 'modify',
	viewPositions: 'viewPositions',
	cancel: 'cancel',
};
